import { z } from "zod";
export const ControlledAiEvalResultV1Schema = z.object({
    schemaVersion: z.literal("controlled-ai-eval.v1.0"),
    requirementId: z.literal("AI-010"),
    ok: z.boolean(),
    humanContinuationRequired: z.boolean(),
    detail: z.string().optional(),
}).strict();
export function assertAiEvalGatePass(input) {
    const malformed = input.payload.trim().length === 0;
    return ControlledAiEvalResultV1Schema.parse({
        schemaVersion: "controlled-ai-eval.v1.0",
        requirementId: "AI-010",
        ok: !malformed,
        humanContinuationRequired: true,
        detail: malformed ? "malformed_or_low_confidence" : undefined,
    });
}
//# sourceMappingURL=eval.js.map